import { createSlice } from "@reduxjs/toolkit";
import { myDonationAPI } from "../../../api/publicApi";

const data = {
  isLoading: false,
  error: "",
  message: null,
  data: null,
};

const myDonationSlice = createSlice({
  name: "myDonation",
  initialState: data,
  reducers: {
    myDonationSlice(state) {
      state.isLoading = true;
    },
    myDonationSliceSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload.results;
      state.message = null;
    },
    myDonationSliceFailure(state, action) {
      
      state.isLoading = false;
      state.message = action.payload ;
    },
    myDonationSliceReset(state) {
      state.isLoading = false;
      state.message = null;
      state.data = null;
      state.error = "";
    },
  },
});

export const myDonationHandler = (user_id:string,body?:{start_date:string | null,end_date:string | null}) => async (dispatch: any) => {
  try {
    dispatch(myDonationAction.myDonationSlice());
    const response: any = await myDonationAPI(user_id, body);
    
    
    dispatch(myDonationAction.myDonationSliceSuccess(response));
  } catch (e: any) {
    dispatch(myDonationAction.myDonationSliceFailure(e?.response?.data?.message));
    // setTimeout(() => {
    //   dispatch(myDonationAction.myDonationSliceReset());
    // }, 5000);
    
  }
};
export default myDonationSlice.reducer;
export const myDonationAction = myDonationSlice.actions;
